module.exports = __webpack_public_path__ + "img/th.16d8a189.png";